/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LookupInternalResponseListBaseResponse as ModelsV4CommonLookupInternalResponseListBaseResponse } from '../../models/Models/v4/Common/lookup-internal-response-list-base-response';

export interface V4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params {
  applicationId: string;
}

export function v4PublicApplicationLookupsApplicationIdCountriesGet$Plain(http: HttpClient, rootUrl: string, params: V4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationLookupsApplicationIdCountriesGet$Plain.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>;
    })
  );
}

v4PublicApplicationLookupsApplicationIdCountriesGet$Plain.PATH = '/v4/public/application/lookups/{applicationId}/countries';
